<template>
  <section class="record-item" @click="handleClick">
    <div class="headline">
      <p class="d-flex">
        <span class="name">{{ item.tag_name }}</span>
        <img v-if="item.is_add" class="name-icon" src="@/assets/image/re-print.png">
      </p>

      <span class="size">
        {{ $utils.matchTagSize(item.tag_size) }} mm
      </span>
    </div>
    <div class="thumbail-wrapper">
      <div
        class="tag-thumbnail"
        :style="{backgroundImage: `url(${previewImage})`}"
      ></div>
    </div>

    <div class="footline">
      <p class="d-flex">
        <span class="name">{{ timeTitle }}：</span>
        <span class="value">{{ item.print_time }}</span>
      </p>
      <p class="d-flex">
        <span class="name">{{ printTitle }}：</span>
        <span class="value">{{ item.num }}</span>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'RecordItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    timeTitle() {
      const {
        is_add
      } = this.item
      const title = is_add ? '补打时间' : '打印时间'

      return title
    },
    printTitle() {
      const {
        is_add
      } = this.item
      const title = is_add ? '补打张数' : '打印张数'

      return title
    }
  },
  created() {
    const {
      content,
      tag_size
    } = this.item
    if (!content) return

    let contentArr = JSON.parse(content)
    for (const t of contentArr) {
      if (t.type == "serial_number") {
        t.text = this.item.serial_number
      }
    }
    let contents = JSON.stringify(contentArr)
    
    this.$utils.renderTagImage(contents, tag_size)
    .then(res => {
      if (res) {
        this.previewImage = res
      }
    })
  },
  data() {
    return {
      previewImage: undefined
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
}
</script>

<style lang="less" scoped>
  .record-item {
    background-image: url('~@/assets/image/tag-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 90px 58px 34px;
    .headline, .footline {
      display: flex;
      justify-content: space-between;
    }
    .headline {
      font-size: 40px;
      .name {
        color: @primary-color;
        margin: 0 22px 0 0;
      }
      .size {
        color: @primary-color;
      }
    }
    .name-icon {
      width: 44px;
      height: 44px;
    }
    .thumbail-wrapper {
      padding: 14px;
      background-color: #eee;
      width: 100%;
      height: 382px;
      margin: 20px 0;
    }
    .tag-thumbnail {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    .footline {
      font-size: 40px;
      .value {
        color: @primary-color;
      }
    }
    &:last-of-type {
      background-image: url('~@/assets/image/tag-bg-end.png');
      padding: 90px 58px 60px;
    }
  }
</style>